import { DynamicStandaloneByline, DynamicStandaloneBylineProps } from '@/components/Byline';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { BYLINE_TYPE } from '../Byline';
import { BylineGroup, BylineGroupProps } from './BylineGroup';

export interface StandaloneBylineGroupProps extends StandaloneComponentProps {
  bylines: DynamicStandaloneBylineProps[];
  options?: BylineGroupProps & {
    $byline?: DynamicStandaloneBylineProps;
  };
}

const priorityMap = {
  [BYLINE_TYPE.AUTHOR]: 1,
  [BYLINE_TYPE.PHOTOGRAPHER]: 2,
  [BYLINE_TYPE.FREE]: 3,
};

const byPriority = (prev: DynamicStandaloneBylineProps, cur: DynamicStandaloneBylineProps) => {
  const defaultType = BYLINE_TYPE.AUTHOR;
  return priorityMap[prev.type ?? defaultType] - priorityMap[cur.type ?? defaultType];
};

export const StandaloneBylineGroup: StandaloneComponent<StandaloneBylineGroupProps> = ({
  bylines,
  options,
  ...props
}) => {
  const { $byline: bylineCommonProps, ...baseProps } = options || {};

  return (
    <BylineGroup {...baseProps} {...props}>
      {bylines.sort(byPriority).map((byline, index) => (
        <DynamicStandaloneByline key={index} {...bylineCommonProps} {...byline} />
      ))}
    </BylineGroup>
  );
};

export default StandaloneBylineGroup;
